// src/store/services/usuarioModulos.js
import feathersClient, {
  makeServicePlugin,
  BaseModel,
} from '../../feathers-client';

class UsuarioModulos extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'UsuarioModulos';
  // Define default properties here
  static instanceDefaults() {
    return {};
  }
}
const servicePath = 'usuario-modulos';
const servicePlugin = makeServicePlugin({
  namespaced: true,
  namespace: 'UsuarioModulos',
  Model: UsuarioModulos,
  service: feathersClient.service(servicePath),
  servicePath,
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
});

export default servicePlugin;
